module.exports = __webpack_public_path__ + "static/media/contact.80d18e18.svg";